var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.input || _vm.loading)?_c('div',[_c('span',{staticClass:"text-black"},[_vm._v(" Cargando .. ")])]):_vm._e(),_c('div',{staticClass:"flex justify-center",attrs:{"id":"barcode-viewer-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }